<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  props: {
    data: {
      required: true,
      type: Object
    }
  },
  data: () => ({
    chartdata: {
      labels: [],
      datasets: []
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      barPercentage : 20,
    }
  }),
  mounted() {
    this.chartdata.datasets = this.data.datasets;
    this.chartdata.labels = this.data.labels;
    this.renderChart(this.chartdata, this.options);
  }
};
</script>


